/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import { Chart, registerables } from 'chart.js';
import './echo';
import './google-places-init';
import './google-places-utils';

// Register all Chart.js components
Chart.register(...registerables);

// Make Chart available globally
window.Chart = Chart;
